export const DISABLE_DELAY: boolean = process.env.DISABLE_DELAY === 'true';

export const HEADERS_CORRELATION_NAME: string = process.env.REACT_APP_HEADERS_CORRELATION_NAME || 'your-custom-value';

export const MOCK_ENABLED: boolean = process.env.REACT_APP_MOCK_ENABLED === 'true';

export const DQE_HOST: string = process.env.REACT_APP_DQE_HOST
    || 'https://dqe-api-dev.axa-fr-dev-int.champagne.northeurope.azure.openpaas.axa-cloud.com';
export const DQE_PATHNAME: string = process.env.REACT_APP_DQE_PATHNAME || 'v1.0/dqe';
export const DQE_EMAIL_VALIDATION_ENDPOINT: string = process.env.REACT_APP_DQE_EMAIL_VALIDATION_ENDPOINT || 'email';
export const DQE_PHONE_VALIDATION_ENDPOINT: string = process.env.REACT_APP_DQE_PHONE_VALIDATION_ENDPOINT || 'phone';

export const AMABIS_HOST: string = process.env.REACT_APP_POSTAL_ADDRESS_HOST
    || 'https://api-retirement-recprj.axa.fr';
export const AMABIS_ENDPOINT: string = process.env.REACT_APP_POSTAL_ADDRESS_ENDPOINT || 'postaladdress';

export const BFF_HOST: string = process.env.REACT_APP_BFF_HOST
    || 'https://bff-route-internal-sd-devis-generique-dev-axa-fr.axa-fr-dev-int.champagne.northeurope.azure.openpaas.axa-cloud.com';
export const BFF_PATHNAME: string = process.env.REACT_APP_BFF_PATHNAME || '';
export const BFF_FOLDER_PATH: string = process.env.REACT_APP_BFF_FOLDER_PATH || 'folder';
export const BFF_PERSON_PATH: string = process.env.REACT_APP_BFF_PERSON_PATH || 'person';
export const BFF_LEAD_PATH: string = process.env.REACT_APP_BFF_LEAD_PATH || 'lead';
export const BFF_FIND_ADVISORS_ENDPOINT: string = process.env.REACT_APP_BFF_FIND_ADVISORS_ENDPOINT
    || 'find-advisors';
export const BFF_IDENTIFY_ENDPOINT: string = process.env.REACT_APP_BFF_IDENTIFY_ENDPOINT || 'identify';
export const BFF_REQUEST_CONTACT_ENDPOINT: string = process.env.REACT_APP_BFF_REQUEST_CONTACT_ENDPOINT
    || 'request-contact';
